
import React, { useState } from 'react';
import BlockButton from '../contacts/BlockButton';
import PriorityButton from '../contacts/PriorityButton';

import { ReactComponent as IconCall } from '../../assets/icons/call.svg';
import { ReactComponent as IconShare } from '../../assets/icons/share.svg';
import { ReactComponent as IconEdit } from '../../assets/icons/edit.svg';
import { ReactComponent as IconDetails } from '../../assets/icons/info.svg';
import {useNavigate} from "react-router-dom";
import {ucwords} from "../../utils";
import useAlert from '../../hooks/useAlert';


export default function CallBtns({ itemGroup, setRawList, infoBtnTarget = 'chiamata' }) {
    const navigate = useNavigate();
    const { id, numero, chiamante_id, chiamante_title, parlato_con, lastCallTime, blocco, priorita} = itemGroup;
    const alert = useAlert();
    let chiamante_title_lower = ucwords(chiamante_title)
    let parlato_con_lower = ucwords(parlato_con)
    return (
        <div className="vista-btns">
            <button><IconCall onClick={() => navigate('/call-actions', {state: { id, numero, chiamante_title: chiamante_title_lower }})} /></button>
            <button><IconShare onClick={async () => {
                try {
                    await navigator.share({
                        title: 'Condividi chiamata',
                        text:  `Chiamante: ${chiamante_title_lower}\n
                                            Parlato con: ${parlato_con_lower}\n
                                            Ora chiamata: ${lastCallTime}\n
                                            Telefono: ${numero}`,
                    });
                    alert({message: 'Condivisione avvenuta con successo'});
                } catch (err) {
                    alert({message: 'Condivisione annullata o fallita:' + err, type: 'error'});
                }
            }} /></button>
            <BlockButton callId={id} initial={blocco} setRawList={setRawList}/>
            <PriorityButton contattoId={chiamante_id} initial={priorita} contatto_title={chiamante_title_lower} numero={numero} />
            <button><IconEdit onClick={() => navigate('/contatto', { state: { id: chiamante_id } })} /></button>
            <button><IconDetails onClick={() => infoBtnTarget === 'chiamata' ? navigate('/call-info', { state: { itemGroup } }) :  navigate('/contatto-info', { state: { id: chiamante_id } }) } /></button>
        </div>
    );
}